(function($){

	var isHome = $('body').hasClass('home'),
		isPage = $('body').hasClass('page'),
		isMobile = 'ontouchstart' in window,
		isSafari = /apple/i.test(navigator.vendor),
		
		sixMaps = $('.sixsquare-map'),
		sliders = $('.slickSlider'),
		touchhover = $('.touchhover'),
		scrollUp = $('.scroll-up'),
		scrollDown = $('.scroll-down'),
		
		contentTop = 0,
		windowWidth = 0;
		
	// pick random slide if class set on slider: randomInitialSlide
	var rSliders = document.getElementsByClassName('randomInitialSlide');
	if ( rSliders.length ) {
		[...rSliders].forEach( s => {
			c = s.children;
			if ( c.length ) {
				c[Math.round( Math.random() * ( c.length - 1 ) )].classList.add('initialSlide');		
			}
		} );
	}
	
	// Set Page Measurements
	var setMeasurements = function () {
		// Set default VH unit for mobile (Safari toolbar full height fix)
		if ( isMobile && $(window).width() != windowWidth ) {
			windowWidth = $(window).width();
			var vh = window.innerHeight * 0.01; // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
			document.documentElement.style.setProperty('--vh', `${vh}px`);
		}
				
		var hh = $('.header-hero').first();
		if ( hh.length ) {
			contentTop = hh.outerHeight();
		} else {
			contentTop = $('header.header').outerHeight();
		}
		
	};
	
	// Intersection Observer	
	var observer = new IntersectionObserver(function(entries) {
		for(let i=0; i < entries.length; i++) {
			// entries[i]['intersectionRatio']
			// entries[i]['isIntersecting']
			// entries[i]['target']
			if ( entries[i]['isIntersecting'] === true ) {
				entries[i]['target'].classList.remove('pre-init');
			}
		}
	}, { threshold: [0.8] });
	// Example use: timelineContainer.children('.date').each(function() { observer.observe(this); } );
			
$(document).ready(function() {
	setMeasurements();
	
	// BODY ANIMATION TRIGGER
	$('body').removeClass('pre-init');
	
	// Mobile
	if ( isMobile ) $('body').addClass('is-mobile');
	if ( isSafari ) $('body').addClass('is-safari');
	
	// Parallax
	var parallax = new Rellax('.ll',{speed:2})

	// Slick Slider
	sliders.each(function() {
		var t = $(this),
			initialSlide = Math.max(0,t.children('.slide.initialSlide').index());
		
		t.on('init',function(e,slick){
			var t = $(this),
				h = t.height();
				
			if ( slick.options.centerMode ) t.addClass('centerMode');
			if ( ! t.hasClass('hero') ) t.height(h);
		
		}).on('reInit',function(e,slick) {
			var t = $(this),
				h = t.css('height','').height();
				
				if ( ! t.hasClass('hero') ) t.height(h);
				
		}).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
//			var nextSlide = slick.$slides[nextSlide];

			
		}).on('afterChange', function(event, slick, currentSlide) {
//			var slide = $(event.target).find('.slick-current');
			
		}).slick({
			// Default options
/*			infinite: false,
			arrows: false,
			swipeToSlide: true,
			slidesToShow: 3,
			variableWidth: true,
			*/
			initialSlide: initialSlide,
			centerPadding: '20%',
			autoplay: true,
			autoplaySpeed: 5000,
			speed: 600,
			responsive: [
				{ 	breakpoint: 1680,
					settings: {
						centerPadding: '15%'
					}
				}
			]
		});
	});

	// Partners Slick Slider
	$('.slickSliderPartners').slick({
		autoplay: true,
		autoplaySpeed: 0,
		speed: 3000,
		infinite: true,
//		cssEase: 'linear',
		useCSS: true,
		useTransform: false,
		draggable: false,
		arrows: false,
		slidesToShow: 5,
		slidesToScroll: 1,
		centerMode: false,
		pauseOnHover: false,
		touchMove: true,
		waitForAnimate: false,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 824,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1,
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					centerMode: true
				}
			},
		]
	});

	
	// Easy Grid Slider
	var gS = $('.gridSlider').data('gridSliderPos',0); 
	$('<button class="gS_prev"></button><button class="gS_next"></button>').appendTo(gS).click(function(){
		var t = $(this);
		var gS = t.parent('.gridSlider');
		var cur = gS.data('gridSliderPos');
		var move = ( t.hasClass('gS_prev') ? -1 : 1 );
		var slides = gS.children('.cell');
		var maxed = ( ( gS.width() - 1 ) > ( slides.last().position().left ) );
		if ( ( ! maxed || move < 0 ) && (cur + move) >= 0 ) {
			gS.removeClass('gs-' + cur);
			gS.addClass('gs-' + (cur + move) ).data('gridSliderPos', cur + move);
		}
	});

	// Scroll Down widget
	if ( scrollDown.length && contentTop ) {
		scrollDown.click(function(){
			var t = Math.min( (contentTop/400) * 800 , 1600 );
			$('html, body').animate({ scrollTop: contentTop }, t, 'easeInQuad');
		});
	}
	// Scroll Up widget
	if ( scrollUp.length ) {
		scrollUp.on("click", function(){
			var t = Math.round((scrollUp.offset().top/500) * 300);
			$('html, body').animate({ scrollTop: 0 }, t, 'easeOutCubic');
		});
	}
		
	// Resize with throttle
	$(window).on('resize', Foundation.util.throttle( function (event) {
	
		sliders.each(function() {
			var t = $(this),
				h = t.css('height','').height();
				if ( ! t.hasClass('hero') ) t.height(h);
	
		});
	
		setMeasurements();
		
			
	}, 300) ).resize();
	
	// Scrolling with throttle
	$(window).on('scroll', Foundation.util.throttle( function (event) {
	
		var wTop = $(this).scrollTop();
			
		sixSquareMapCheck();
		
		if ( contentTop ) {
			if ( wTop >= contentTop - 20 ) {
				$('header.header').addClass('scrolled');
			} else {
				$('header.header').removeClass('scrolled');
			}
		}
				
		if ( scrollDown.length ) {
			if ( scrollDown.offset().top > contentTop ) {
				scrollDown.addClass('collapse');
			} else {
				scrollDown.removeClass('collapse');
			}
		}
		
		if ( scrollUp.length ) {
			if ( wTop > contentTop ) scrollUp.addClass('visible');
			else scrollUp.removeClass('visible');
		}

			
	}, 300) ).scroll();
	
	// Scrolling 
	$(window).on('scroll', function (event) {
	
	} ).scroll();
	
	function sixSquareMapCheck() {
		// Google Maps
		if ( sixMaps.length ) {
			sixMaps.each(function(i, el) {
				el = $(el);
				if ( el.visible('middle') ) { 
					sixSquareMapFeatures( el );
					sixMaps = sixMaps.not(this);
				}
			});
		}
	}
	
	// SVG load
	$('img.svg-load').each( function() { 
		var $img = $(this);
		var imgID = $img.attr('id');
		var imgClass = $img.attr('class');
		var imgURL = $img.attr('src');
		$.get({
			url: imgURL,
			cache: true,
			dataType: 'xml',
			success: function (data) {
				// Get the SVG tag, ignore the rest
				var $svg = $(data).find('svg');
				// Add replaced image's ID to the new SVG
				if(typeof imgID !== 'undefined') {
					$svg = $svg.attr('id', imgID);
				}
				// Add replaced image's classes to the new SVG
				if(typeof imgClass !== 'undefined') {
					$svg = $svg.attr('class', imgClass);
				}
				// Remove any invalid XML tags as per http://validator.w3.org
				$svg = $svg.removeAttr('xmlns:a');
				// Replace image with new SVG
				$img.replaceWith($svg);
			}
		});
	});
	
	// Top Bar toggle (mobile menu)
	$('header button.menu-icon').click(function() {
		var menu = $('#top-bar-menu');
		if ( menu.hasClass('expanded') ) {
			menu.removeClass('expanded');
			this.classList.remove('open');
		} else {
			menu.addClass('expanded');
			this.classList.add('open');
		}
	});
	
	// Off Canvas links: close on click. This ensures the menu is hidden when navigating back. Reducing the transition was somehow necessary. It is fixed by onClick code in nav-offcanvas-topbar.php. The callback below doesn't get called.
	$('#off-canvas a').click(function(e){
		if ( $(this).parent().hasClass('is-accordion-submenu-parent') ) return true;
		if ( $(this).attr('target') == "_blank" ) return true;
		if ( $(this).parent().hasClass('noclick') ) return false;
		
		var t = $(this);
				
		// don't follow link	
		e.preventDefault();
		
		// Close off-canvas
		$('#off-canvas').foundation('close');
		
		// Trigger body pageLoader
//		$('body').addClass('loading');
		
		// follow link after off-canvas closes
		$('#off-canvas').on('closed.zf.offCanvas', function () {
			window.location = t.attr('href');
		});		

		return false;

	});
		
	// Off-Canvas inner: stop propagation of transitionend event causing premature transition on close
	$('.offcanvas-full-screen-inner').on('transitionend',(e)=>e.stopPropagation());

	// Off-Canvas Open [verified]
	$('#off-canvas').on('opened.zf.offCanvas', function (e) {

	//	document.activeElement.blur();
		

	});
	
	// Off-Canvas Open Ended [verified]
	$('#off-canvas').on('openedEnd.zf.offCanvas', function (e) {
		
		sixSquareMapCheck();
		document.activeElement.blur();
		
	});

	// Off-Canvas Close [verified]
	$('#off-canvas').on('close.zf.offCanvas', function (e) {

	});
	
	// Off-Canvas Closed [verified]
	$('#off-canvas').on('closed.zf.offCanvas', function (e) {

	});
	
	// Off-Canvas accordion menu OPEN
//	$('#offcanvas-nav').foundation('showAll');
	
	// Touch hover methods
	if ( isMobile ) {
		touchhover.on('touchstart', function(e) {
			var t = $(this);
			
			if ( t.hasClass('hover') ) {
				return true;
			} else {
				t.addClass('hover');
				touchhover.not(this).removeClass('hover');
				e.preventDefault();
				return false;
			}
			
		});
		$('body').on('touchstart',function(e) {
			touchhover.removeClass('hover');
		});
	}
	
	/* // Load More Posts
	$('.loadMorePosts').each(function(){

		var _t = $(this),
			id = _t.attr('id'),
			winVar = 'loadMorePosts_' + id;
			
		if ( typeof window[winVar] != 'undefined' && window[winVar].current_page && window[winVar].max_page ) {
			$('<span class="button doLoadMorePosts">' + window[winVar].buttonLabel +'</span>')
			.data('lmpID',id)
			.click(function(){nsLoadMorePosts(this);})
			.insertAfter(_t).wrap('<div class="container__loadMoreButton"></div>');
			_t.find('.wp-pagenavi').hide();
		}
		
	});
	
	function nsLoadMorePosts(button){
	//	if ( typeof winVar != 'string' || ! winVar.length ) return;
		
		var button = $(button),
			id = button.data('lmpID'),
			winData = window['loadMorePosts_' + id],
			data = {
				'action': 'sixloadmoreposts',
				'template': winData.template,
				'page' : winData.current_page
			};
 
		$.ajax({ // you can also use $.post here
			url : winData.ajaxurl, // AJAX handler
			data : data,
			type : 'POST',
			beforeSend : function ( xhr ) {
				button.text(winData.buttonLabelLoading + '...'); // change the button text, you can also add a preloader image
			},
			success : function( data ){
				if( data ) { 
					button.text( winData.buttonLabel );
					
			//		$('#' + id).append(data); // insert new posts
					// insert new posts
					var newContent = jQuery(data);
					
					newContent.each(function(){ 
						jQuery(this).hide(); 
					});
					
					newContent.appendTo('#' + id).each(function(i){ 
						jQuery(this).delay(i*250).fadeIn(2500);
					});
					
					winData.current_page++;
 
					if ( winData.current_page == winData.max_page ) button.fadeOut(250); // if last page, remove the button
 
					// $( document.body ).trigger( 'post-load' );
				} else {
					button.remove(); // if no data, remove the button as well
				}
			}
		});
	} */
	
}); // document.ready()

$(window).on('load', function() {


});

// Breakpoint Change
$(window).on('changed.zf.mediaquery ready', function(event, newSize, oldSize) {
	if ( typeof newSize == 'undefined' ) newSize = Foundation.MediaQuery.current;

	if ( newSize == 'small' ) {
		
	} else if ( oldSize == 'small' ) {

	} 
	if ( newSize && oldSize ) { // actual change, not first call (ready)
		
		// Easy Grid Slider reset
		$('.gridSlider').each( function() {
			var gS = $(this);
			var cur = gS.data('gridSliderPos');
			gS.removeClass('gs-' + cur).data('gridSliderPos',0);
		});
		
	}
});


// Gravity Forms: FORM POST RENDER (This includes initial form load, going to the next/previous page on multi-page forms, form rendered with validation errors, confirmation message displayed, etc.)
$(document).bind('gform_post_render', function(event,formID){
	
	// Button Style clicks and check
	jQuery('#gform_wrapper_' + formID + ' .gf_button_style .ginput_container .gfield_radio .gchoice').click(function(){
		var t = jQuery(this),
			i = t.children('input'),
			val = i.val(),
			all = t.siblings('.gchoice');
	
		all.removeClass('checked').children('input').attr('checked',false);
		i.attr('checked',true).change();
		t.addClass('checked');
	
	}).each( function() {
	
		if ( jQuery(this).children('input').is(':checked') ) {
			jQuery(this).addClass('checked');
		}
	
	});
	
});
		
// fn: Visible
$.fn.visible = function(type) {
	var t            = $(this);
	if ( typeof t.offset() != "object" ) { console.log('visible: not object.'); console.log(this); return false; }
	var	$w            = $(window),
		viewTop       = $w.scrollTop(),
		viewBottom    = viewTop + $w.height(),
		_height		  = t.height(),
		offset        = t.offset(),
		_top          = offset.top,
		_middle		  = _top + (_height/2),
		_bottom       = _top + _height,
		_10			  = _height*0.1;
		
		if ( offset.left <= (0 - t.width()) || offset.left > $w.width() ) return false;
		
		switch (type) {
			case 'top': return (_top +_10 >= viewTop) && (_top < viewBottom);
			case 'middle': return (_middle >= viewTop) && (viewBottom >= _middle);
			//case 'full':
			default: return (_bottom <= viewBottom) && (_top >= viewTop);
		}
};

// grab
// Example useage: if ( !isMobile ) timelineContainer.on('mousedown', grabMouseDown);
var grab = { top: 0,
			left: 0,
			x: 0,
			y: 0,
			snapUnset: ((typeof InstallTrigger !== 'undefined') || (!!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime))), // Unset scrollsnap for Firefox and Chrome
			el: null
		},
grabMouseDown = function(e) {
	var t = jQuery(this);
    grab = {
        // The current scroll 
        left: this.scrollLeft,
        top: this.scrollTop,
        // Get the current mouse grabition
        x: e.clientX,
        y: e.clientY,
        snapUnset: grab.snapUnset,
        el: this
    };
    
    // Change the cursor and prevent user from sgrab.elcting the text
    grab.el.style.cursor = 'grabbing';
	grab.el.style.userSelect = 'none';
	if ( grab.snapUnset ) grab.el.style.scrollSnapType = 'unset';

    document.addEventListener('mousemove', grabMouseMove);
    document.addEventListener('mouseup', grabMouseUp);
},
grabMouseMove = function(e) {
    // How far the mouse has been moved
    const dx = e.clientX - grab.x;
    const dy = e.clientY - grab.y;

    // Scroll the grab.elment
//    grab.el.scrollTop = grab.top - dy;
    grab.el.scrollLeft = grab.left - dx;
},
grabMouseUp = function() {
    grab.el.style.removeProperty('cursor');
    grab.el.style.removeProperty('user-select');
    if ( grab.snapUnset ) grab.el.style.removeProperty('scroll-snap-type');
    
    document.removeEventListener('mousemove', grabMouseMove);
    document.removeEventListener('mouseup', grabMouseUp);
};

// Google Maps Callback fn
window.sixSquareMapInit = function () {
	// Create a new StyledMapType object, passing it an array of styles,
	// and the name to be displayed on the map type control.
	var styledMapType = new google.maps.StyledMapType([
	  {
		"elementType": "geometry",
		"stylers": [{
			"color": "#f5f5f5"
		  }]
	  },
	  {
		"elementType": "labels.icon",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#616161"
		  }]
	  },
	  {
		"elementType": "labels.text.stroke",
		"stylers": [{
			"color": "#f5f5f5"
		  }]
	  },
	  {
		"featureType": "administrative.land_parcel",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#bdbdbd"
		  }]
	  },
	  {
		"featureType": "poi",
		"elementType": "geometry",
		"stylers": [{
			"color": "#eeeeee"
		  }]
	  },
	  {
		"featureType": "poi",
		"elementType": "labels.text",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"featureType": "poi",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#757575"
		  }]
	  },
	  {
		"featureType": "poi.business",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"featureType": "poi.business",
		"elementType": "labels.text",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"featureType": "poi.park",
		"elementType": "geometry",
		"stylers": [{
			"color": "#e5e5e5"
		  }]
	  },
	  {
		"featureType": "poi.park",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#9e9e9e"
		  }]
	  },
	  {
		"featureType": "road",
		"elementType": "geometry",
		"stylers": [{
			"color": "#ffffff"
		  }]
	  },
	  {
		"featureType": "road",
		"elementType": "labels.icon",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"featureType": "road.arterial",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#757575"
		  }]
	  },
	  {
		"featureType": "road.highway",
		"elementType": "geometry",
		"stylers": [{
			"color": "#dadada"
		  }]
	  },
	  {
		"featureType": "road.highway",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#616161"
		  }]
	  },
	  {
		"featureType": "road.local",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#9e9e9e"
		  }]
	  },
	  {
		"featureType": "transit",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"featureType": "transit.line",
		"elementType": "geometry",
		"stylers": [{
			"color": "#e5e5e5"
		  }]
	  },
	  {
		"featureType": "transit.station",
		"elementType": "geometry",
		"stylers": [{
			"color": "#eeeeee"
		  }]
	  },
	  {
		"featureType": "water",
		"elementType": "geometry",
		"stylers": [{
			"color": "#80bac5"
		  }]
	  },
	  {
		"featureType": "water",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#9e9e9e"
		  }]
	  }
	], {name: 'Styled Map'});
	
	sixMaps.each(function() {
	
		var googleMap = new google.maps.Map( this, {
			zoom: 15,
			center: new google.maps.LatLng( sixScript.gmap_lat, sixScript.gmap_long ),
			mapTypeId: 'roadmap',
			mapTypeControl: false,
			fullscreenControl: false,
			streetViewControl: false,
			scrollwheel: false,
			"featureType": "poi.business",
			"stylers": [
				{
					"visibility": "off"
				}
			]		
		});

		//Associate the styled map with the MapTypeId and set it to display.
		googleMap.mapTypes.set('styled_map', styledMapType);
		googleMap.setMapTypeId('styled_map');
		
		$(this).data('gmap', googleMap);
	
	});

}
// Google Maps Feature / pin / display fn
function sixSquareMapFeatures( map ) {

	if ( typeof map != 'object' ) return false;
	
	var googleMap = map.data('gmap');

	if ( typeof map.data('gmapMarkers') == 'undefined' ) {
		// First init!
		var features = [
			{
				position: new google.maps.LatLng( sixScript.gmap_lat, sixScript.gmap_long ),
				type: 'info',
				title: sixScript.blogname ,
				animation: google.maps.Animation.DROP
			}
		];
		var icon = {
			url: sixScript.gmap_icon,
			scaledSize: new google.maps.Size(34,52),
//			origin: new google.maps.Point(0,0),
			anchor: new google.maps.Point(17,52)
		};
		// Create markers.
		map.data('gmapMarkers',[]);

		features.forEach(function(feature) {
		  var marker = new google.maps.Marker({
			position: feature.position,
			map: googleMap,
			icon: icon,
			animation: feature.animation,
			title: feature.title,
			clickable: true
		  }).addListener('click', function(e) {
					var pid = sixScript.gmap_placeid,
						destination = ( pid && pid.length? pid : sixScript.gmap_lat + ',' + sixScript.gmap_long),// sixScript.blogname ),
						url = "https://www.google.com/maps/dir/?api=1&destination=" + destination + "&destination_place_id=" + pid;
						window.open(url);
			});
		  map.data('gmapMarkers').push(marker);
		});

	} else {

		// reinit
		googleMap.setCenter( new google.maps.LatLng( sixScript.gmap_lat, sixScript.gmap_long ) );
		map.data('gmapMarkers')[0].setAnimation( google.maps.Animation.DROP );
		
	}
	
}

// jQuery Easings
$.extend( $.easing, {
	easeOutCubic: function (x, t, b, c, d) {
			return c*((t=t/d-1)*t*t + 1) + b;
		},
	easeInQuad: function (x, t, b, c, d) {
	    return c*(t/=d)*t + b;
	},
});


})(jQuery);